// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__K1OvH","bg":"Profile_bg__PNcvM"};